import config from '../config/environment';
import supabase from '../config/supabase';
import type { PaginatedResponse } from '../types/student';
import type {
  WorkoutDeliveryFilters,
  WorkoutDeliveryRow,
} from '../types/workoutDeliveryManagement';
import { handleServiceError } from '../utils/errorHandler';

export type WorkoutDeliveryPaginatedResponse = PaginatedResponse<WorkoutDeliveryRow>;

class WorkoutDeliveryManagementServiceClass {
  async listPaginated(
    page: number = 1,
    pageSize: number = 10,
    filters: WorkoutDeliveryFilters = {},
  ): Promise<WorkoutDeliveryPaginatedResponse> {
    try {
      const { data: sessionData } = await supabase.auth.getSession();
      const token = sessionData?.session?.access_token;

      const url = new URL(`${config.supabaseFunctionsUrl}/list-paginated-workout-deliveries`);
      url.searchParams.set('page', String(page));
      url.searchParams.set('pageSize', String(pageSize));
      if (filters.searchName) {
        url.searchParams.set('searchName', filters.searchName);
      }

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          apikey: config.supabaseAnonKey,
        },
      });

      if (!response.ok) {
        const body = await response.json().catch(() => ({} as { error?: string }));
        throw new Error(body.error || 'Erro ao listar entregas de treinos.');
      }

      return await response.json() as WorkoutDeliveryPaginatedResponse;
    } catch (error) {
      throw handleServiceError(error, 'listar entregas de treinos');
    }
  }
}

export const WorkoutDeliveryManagementService = new WorkoutDeliveryManagementServiceClass();
